var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterCIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4724_17468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.42871 11.3334C3.42871 12.3652 3.63194 13.3869 4.0268 14.3402C4.42166 15.2935 5.00041 16.1596 5.73001 16.8892C6.45962 17.6188 7.32578 18.1976 8.27906 18.5925C9.23233 18.9873 10.254 19.1905 11.2859 19.1905C12.3177 19.1905 13.3394 18.9873 14.2927 18.5925C15.2459 18.1976 16.1121 17.6188 16.8417 16.8892C17.5713 16.1596 18.15 15.2935 18.5449 14.3402C18.9398 13.3869 19.143 12.3652 19.143 11.3334C19.143 10.3016 18.9398 9.27987 18.5449 8.3266C18.15 7.37333 17.5713 6.50716 16.8417 5.77756C16.1121 5.04796 15.2459 4.46921 14.2927 4.07435C13.3394 3.67949 12.3177 3.47626 11.2859 3.47626C10.254 3.47626 9.23233 3.67949 8.27906 4.07435C7.32578 4.46921 6.45962 5.04796 5.73001 5.77756C5.00041 6.50716 4.42166 7.37333 4.0268 8.3266C3.63194 9.27987 3.42871 10.3016 3.42871 11.3334Z",
    stroke: "#616161",
    strokeWidth: 0.952381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0317 9.36909C12.5228 8.92187 11.8611 8.68801 11.1842 8.71614C10.5074 8.74427 9.86736 9.03222 9.39734 9.52012C8.92801 10.0071 8.66577 10.6571 8.66577 11.3334C8.66577 12.0097 8.92801 12.6597 9.39734 13.1466C9.86736 13.6345 10.5074 13.9225 11.1842 13.9506C11.8611 13.9787 12.5228 13.7449 13.0317 13.2977",
    stroke: "#616161",
    strokeWidth: 0.952381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4724_17468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.9524,
    height: 20.9524,
    fill: "white",
    transform: "translate(0.80957 0.857178)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterCIcon);
export default __webpack_public_path__ + "static/media/footerCIcon.b7d53cc45aab89913b92af1354c77d8b.svg";
export { ForwardRef as ReactComponent };